require('./library/js/event-calendar.js');

import Vue from "vue/dist/vue.esm";

import CalendarFilterWidget from "./library/js/components/calendar/calendarFilterWidget.vue";

Vue.component('calendar-filter-widget', CalendarFilterWidget);

window.calendarVueApp = new Vue()
    .$mount("#calendar-filter-wrapper");